
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

interface SaveTemplateInput {
  title: string;
  description: string | null;
  hebrew_title: string | null;
  hebrew_description: string | null;
}

export const useSaveTaskTemplateMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (templateData: SaveTemplateInput) => {
      const { data: { session } } = await supabase.auth.getSession();
      if (!session) throw new Error('No session');

      const { data, error } = await supabase
        .from('task_templates')
        .insert({
          title: templateData.title,
          description: templateData.description,
          hebrew_title: templateData.hebrew_title,
          hebrew_description: templateData.hebrew_description,
          user_id: session.user.id,
          template_type: 'custom'
        })
        .select()
        .single();

      if (error) throw error;
      return data;
    },
    onSuccess: () => {
      // Invalidate task templates query to refresh the list
      queryClient.invalidateQueries({ queryKey: ['taskTemplates'] });
    },
  });
};
